import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Constant Nutrition Plan Preparation',
  description: 'Every week you spend hours creating personalized nutrition plans, organizing educational materials, preparing consultation documents, and adapting recommendations for clients with different goals, health conditions, lifestyles, and dietary needs.'
}, {
  emoji: '⚠️',
  title: 'Unsure About the Next Step',
  description: 'You constantly wonder whether your client is ready to move to the next stage of their nutrition plan, introduce new nutritional strategies, adjust calorie targets, or reinforce healthier habits to improve long-term adherence.'
}, {
  emoji: '📚',
  title: 'Resources Everywhere',
  resources: ['Assessment forms.', 'Meal planning templates.', 'Food journals.', 'Educational handouts.', 'Habit trackers.', 'Progress monitoring sheets.'],
  description: "Everything exists… But it's scattered across websites, online courses, old PDFs, cloud folders, and countless documents saved on your computer. Nothing is organized into one complete professional system you can confidently use every single day."
}, {
  emoji: '😩',
  title: 'Administrative Burnout',
  description: 'Between initial assessments, nutrition planning, follow-up consultations, client documentation, educational resources, progress tracking, and endless paperwork, there\u2019s very little time left to focus on what truly matters: helping your clients build healthier habits and achieve lasting results.'
}];
export function PainSection() {
  return <section className="py-8 px-4 bg-white border-y-4 border-brand-rose/20" data-id="element-117">
      <div className="max-w-4xl mx-auto" data-id="element-118">
        <h2 className="text-2xl sm:text-3xl font-serif font-extrabold text-center text-brand-graphite mb-2 uppercase tracking-tight" data-id="element-119">
          DOES THIS SOUND FAMILIAR?
        </h2>

        <p className="text-base sm:text-lg text-brand-graphite/90 font-medium text-center mb-6 max-w-2xl mx-auto leading-snug" data-id="element-120">
          You love helping your clients improve their health, but preparing
          every consultation is consuming your entire week. If you're a
          Nutritionist, Dietitian, Clinical Nutritionist, Sports Nutritionist,
          or Functional Nutrition Professional working in private practice,
          wellness clinics, hospitals, health centers, or online consultations,
          you've probably experienced at least one of these situations:
        </p>

        <div className="grid sm:grid-cols-2 gap-3" data-id="element-121">
          {pains.map((pain, i) => <div key={i} className="bg-brand-cream p-4 rounded-lg border-2 border-brand-rose/30 shadow-sm flex flex-col items-center text-center sm:items-start sm:text-left sm:flex-row gap-3" data-id="element-122">
              <div className="text-3xl shrink-0" data-id="element-123">{pain.emoji}</div>
              <div data-id="element-124">
                <h3 className="text-base font-bold text-brand-petrol mb-1 uppercase tracking-wide" data-id="element-125">
                  {pain.title}
                </h3>
                {pain.resources && <ul className="text-brand-graphite/80 text-sm font-semibold leading-snug mb-1.5 grid grid-cols-2 gap-x-3" data-id="element-126">
                    {pain.resources.map((r, ri) => <li key={ri} data-id="element-127">{r}</li>)}
                  </ul>}
                <p className="text-brand-graphite/80 text-sm font-medium leading-snug" data-id="element-128">
                  {pain.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}